import { IConfigSeller } from '@/models/configSeller'
import { useSelector } from 'react-redux'

/**
 * Sellers que ya tienen habilitado el rediseño (Home con KPIs, login nuevo y detalle
 * del trade-in por pasos). El resto sigue viendo la interfaz anterior.
 *
 * Para liberar el rediseño a otro seller basta con agregar su FOLDER_APP a esta lista
 * —es el único lugar que hay que tocar—, y para revertirlo, sacarlo.
 */
export const REDESIGN_SELLERS = [
  'ti_telcel_mx'
]

/** Versión sin hook, para cuando ya se tiene la config a mano (p. ej. dentro de otro selector). */
export const hasRedesign = (folderApp: string | undefined | null): boolean =>
  REDESIGN_SELLERS.includes(String(folderApp ?? ''))

/** true si el seller de la sesión actual ve el rediseño. */
export const useHasRedesign = (): boolean => {
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  return hasRedesign(configSeller?.config?.s3?.FOLDER_APP)
}
